import { mapGetters } from 'vuex'

const DAY = 3600 * 1000 * 24

export default {
  computed: {
    ...mapGetters({
      siteFiexdHeader: 'siteFiexdHeader',
      siteTopNavEnable: 'siteTopNavEnable',
      siteSidebarLogo: 'siteSidebarLogo',
      sidebarOpened: 'sidebarOpened',
      avatar: 'avatar',
      msgtotal: 'msgtotal',
      username: 'name',
      role: 'role',
      permission_routes: 'permission_routes',
      categories: 'categories',
      companyId: 'companyId',
      devices: 'devices',
      teles: 'teles',
      metes: 'metes',
      spores: 'spores',
      traps: 'traps',
      cameras: 'cameras',
      scabs: 'scabs',
      rodents: 'rodents'
    })
  }
}

export const datePickOption = {
  data() {
    return {
      pickOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - DAY)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - DAY * 7)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一个月前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - DAY * 30)
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  }
}
